import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import VatIssue from "./VatIssue";
import VatApply from "./VatApply";
import Reposit from "./VatReposit";
import { Link } from "react-router-dom";
import { RootState, useAppDispatch, useAppSelector } from "store";
import { useEffect } from "react";
import { setMenuIndex } from "store/userSlice";
import { UserRole } from "lib/types";
import { cn } from "lib/utils";
import { PageContainer, PageHeader } from "components/Layout/PageShell";

const VatBankPage = ({ param }: { param: string }) => {
  const dispatch = useAppDispatch();
  const me = useAppSelector((state: RootState) => state.user.me);

  useEffect(() => {
    dispatch(setMenuIndex(4));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageContainer>
      <PageHeader
        title="세무•입금"
        description="세금계산서 요청·발급과 입금 확인을 처리합니다."
      />
      <Tabs defaultValue={param} className="w-full pb-3">
        <TabsList
          className={cn(
            "grid w-full",
            me.role === UserRole.ADMIN ? "grid-cols-3" : "grid-cols-2"
          )}
        >
          <Link to="/school/tax/issue" className="w-full">
            <TabsTrigger value="issue" className="w-full">
              세금계산서 요청
            </TabsTrigger>
          </Link>
          <Link to="/school/tax/apply" className="w-full">
            <TabsTrigger value="apply" className="w-full">
              세금계산서 발급
            </TabsTrigger>
          </Link>
          {me.role === UserRole.ADMIN && (
            <Link to="/school/tax/deposit" className="w-full">
              <TabsTrigger value="deposit" className="w-full">
                입금확인
              </TabsTrigger>
            </Link>
          )}
        </TabsList>
        <TabsContent value="issue">
          <VatIssue />
        </TabsContent>
        <TabsContent value="apply">
          <VatApply />
        </TabsContent>
        <TabsContent value="deposit">
          <Reposit />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
};

export default VatBankPage;
